module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.receiveTypeAll),
      expression: "!receiveTypeAll"
    }],
    attrs: {
      "label": _vm.title + '类型'
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.present_type),
      expression: "data.present_type"
    }],
    domProps: {
      "value": (_vm.data.present_type)
    },
    on: {
      "input": function($event) {
        _vm.data.present_type = $event
      }
    }
  }, [_vm._t("presentType"), _vm._v(" "), _vm._l((_vm.presentTypeOptions), function(option) {
    return _c('el-radio', {
      attrs: {
        "label": option.id
      }
    }, [_vm._v(_vm._s(option.name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "m-b-10"
  })], true)]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receiveTypePerson || _vm.receiveTypeAll),
      expression: "receiveTypePerson || receiveTypeAll"
    }],
    attrs: {
      "label": _vm.title + '配置',
      "prop": "receive_user"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.receiveTypeAll),
      expression: "!receiveTypeAll"
    }]
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.receive_user.founder_status),
      expression: "data.receive_user.founder_status"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.data.receive_user.founder_status)
    },
    on: {
      "input": function($event) {
        _vm.data.receive_user.founder_status = $event
      }
    }
  }, [_vm._v("发起人")]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.receive_user.founder_higher_status),
      expression: "data.receive_user.founder_higher_status"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.data.receive_user.founder_higher_status)
    },
    on: {
      "input": function($event) {
        _vm.data.receive_user.founder_higher_status = $event
      }
    }
  }, [_vm._v("发起人上级")]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.receive_user.back_higher_status),
      expression: "data.receive_user.back_higher_status"
    }],
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.data.receive_user.back_higher_status)
    },
    on: {
      "input": function($event) {
        _vm.data.receive_user.back_higher_status = $event
      }
    }
  }, [_vm._v("上一步处理人上级")]), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.receive_user.free_status),
      expression: "data.receive_user.free_status"
    }],
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    domProps: {
      "value": (_vm.data.receive_user.free_status)
    },
    on: {
      "input": function($event) {
        _vm.data.receive_user.free_status = $event
      }
    }
  }, [_vm._v("自定义配置")])]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_ids),
      expression: "data.user_ids"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.typePersonSelf || _vm.receiveTypeAll),
      expression: "typePersonSelf || receiveTypeAll"
    }],
    staticClass: "w-230",
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": '请选择自定义' + _vm.title
    },
    domProps: {
      "value": (_vm.data.user_ids)
    },
    on: {
      "input": function($event) {
        _vm.data.user_ids = $event
      }
    }
  }, _vm._l((_vm.users), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.realname,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receiveTypeGroup || _vm.receiveTypeAll),
      expression: "receiveTypeGroup || receiveTypeAll"
    }],
    attrs: {
      "label": "接收分组"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.group_ids),
      expression: "data.group_ids"
    }],
    staticClass: "w-230",
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "请选择接收分组"
    },
    domProps: {
      "value": (_vm.data.group_ids)
    },
    on: {
      "input": function($event) {
        _vm.data.group_ids = $event
      }
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receiveTypeStruct || _vm.receiveTypeAll),
      expression: "receiveTypeStruct || receiveTypeAll"
    }],
    attrs: {
      "label": "接收部门配置",
      "prop": "struct_ids"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.struct_ids),
      expression: "data.struct_ids"
    }],
    staticClass: "w-230",
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "请选择接收部门"
    },
    domProps: {
      "value": (_vm.data.struct_ids)
    },
    on: {
      "input": function($event) {
        _vm.data.struct_ids = $event
      }
    }
  }, _vm._l((_vm.structs), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receiveTypeRelation || _vm.receiveTypeAll),
      expression: "receiveTypeRelation || receiveTypeAll"
    }],
    attrs: {
      "label": _vm.title + '配置',
      "prop": ""
    }
  }, [_c('span', [_vm._v("本表字段：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.related_field_config.field_id),
      expression: "data.related_field_config.field_id"
    }],
    staticClass: "w-230 m-b-5",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择本表字段"
    },
    domProps: {
      "value": (_vm.data.related_field_config.field_id)
    },
    on: {
      "change": function($event) {
        _vm.relationChange(_vm.data.related_field_config.field_id)
      },
      "input": function($event) {
        _vm.data.related_field_config.field_id = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.name + '(' + item.default.title + ')',
        "value": item.default.field_id
      }
    })
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRealtionForigen),
      expression: "isRealtionForigen"
    }]
  }, [_c('span', [_vm._v("关联外键字段：")]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.related_field_config.related_field_id),
      expression: "data.related_field_config.related_field_id"
    }],
    staticClass: "w-230",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择外键关联字段"
    },
    domProps: {
      "value": (_vm.data.related_field_config.related_field_id)
    },
    on: {
      "input": function($event) {
        _vm.data.related_field_config.related_field_id = $event
      }
    }
  }, _vm._l((_vm.relationForignList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.field_id
      }
    })
  }))])]), _vm._v(" "), _vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0b3c180!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/receiverConfig.vue
// module id = 1982
// module chunks = 2